import React from 'react';
import classNames from 'classnames';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import EnhancedTableHead from '../../utils/EnhancedTableHead';
import { commonTablestyles } from '../../utils/Style';
import ReactTable from 'react-table';
import '../../css/react-table/react-table.css';

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    loadingHeight: {
        height: "100%",
        position: "fixed",
        top: "0",
        right: "0"
    },
    container: {
        display: "flex",
        flexWrap: "wrap",
        width: 350
    },
    button: {
        width: 300,
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: 10
    },
    alreadySignIn: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        marginRight: "auto"
    },
    success: {
        marginTop: 10,
        marginBottom: 10,
        marginLeft: "auto",
        
        marginRight: "auto",
        color: "green"
    }
});
class RawModisTable extends React.Component {

    
  columns = [
    {
     
        "Header": "Date acquired",
        "accessor": 'acqdate', 
        }, {
     
            "Header": "Time acquired",
            "accessor": 'acqtime', 
            },
        {
        "Header": "Latitude",
        "accessor": 'latitude', 
        },
        {
            "Header": "Longitude",
            "accessor":'longitude', 
         },
         {
            "Header": "Confidence",
            "accessor": "confidence",
        },
        {
        "Header": "Brightness T31",
        "accessor": "bright_t31",
        },
        {
        "Header": "Brightness",
        "accessor": "brightness",
        },
        {
        "Header": "Day or Night",
        "accessor": "day_night",
        },
        {
            "Header": "Action",
            "accessor": "action",
            minWidth: 300,
        }];
     
    state = {
        open: false,
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            objects: [],
            selected: [],
            data:[],
            order: 'asc',
            orderBy: '',
            page: 0,
        };
    }

    componentWillMount() {
        this.setState({ data: this.props.data });
        console.log( this.props.data)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ selected: nextProps.selected });
        //this.setState({ page: nextProps.page }); 
        if (nextProps.data != this.state.data) {
            this.setState({ data: nextProps.data });
        }
    } 
 
    isSelected = id => this.state.selected.indexOf(id) !== -1;

    renderReactTable(data,classes,columns){
        console.log(data)
        return (
            <Paper>
            <Grid container className={classes.root}>
                    <Grid item xs={12}>
                            <Grid container justify='center' alignItems='center'>
                                Raw MODIS List

                            </Grid>
                            <Grid container justify='center' alignItems='center'>
                                <ReactTable 
                                    className="-striped -highlight"
                                    defaultPageSize={100}
                                    data={ data}
                                    columns={columns}
                                    style={{width:'98%'}}
                                >

                                </ReactTable>

                            </Grid>
                    </Grid>
                    </Grid>
                     
            </Paper>
        );
    }

    render() {
        const { classes, columnData, handleChangeRowsPerPage, handleModalOpen, handleChangePage, countuserValue, rowsPerPage, emptyRows, selected, handleClick, handleSelectAllClick } = this.props;
        const { objects, order, orderBy, page,data } = this.state;
        return (
           
        this.renderReactTable( data, classes, this.columns)
        );
    }
}

export default withStyles(commonTablestyles)(RawModisTable);


// WEBPACK FOOTER //
// ./src/utils/MainTable/RawModisTable.js